import { BezierCurveEase, Vector3 } from 'babylonjs';

// TODO: Get rid of UPPER_BETA_LIMIT magic numbers
export const ARC_ROTATE_CAMERA_CONFIG = {
  INERTIA: 0.9,
  WHEEL_PRECISION: 40,
  USE_BOUNCING_BEHAVIOR: false,
  ANGULAR_SENSIBILITY_X: 1300,
  ANGULAR_SENSIBILITY_Y: 1300,
  LOWER_BETA_LIMIT: 0,
  UPPER_BETA_LIMIT: Math.PI,
  LOWER_RADIUS_LIMIT: 0.1,
  UPPER_RADIUS_LIMIT: 1000,
  INERTIAL_PANNING_X: 1,
  INERTIAL_PANNING_Y: 1,
};

export const ArcRotateCameraAnimationConfig = {
  SPEED: 65,
  ADDITIONAL_HEIGHT: 20,
  FRAME_COUNT: 50,
  EASE: new BezierCurveEase(0.59, 0.58, 0.68, 0.69),
  LATERAL_LEFT: {
    name: 'DataDonutMenuW',
    camEndPos: new Vector3(-85, 15, 0),
    targetEndPos: new Vector3(5, 15, 0),
  },
  LATERAL_RIGHT: {
    name: 'DataDonutMenuE',
    camEndPos: new Vector3(85, 15, 0),
    targetEndPos: new Vector3(-5, 15, 0),
  },
  BACK: {
    name: 'DataDonutMenuN',
    camEndPos: new Vector3(0, 15, 85),
    targetEndPos: new Vector3(0, 15, -5),
  },
  FRONT: {
    name: 'DataDonutMenuS',
    camEndPos: new Vector3(0, 15, -85),
    targetEndPos: new Vector3(5, 15, 5),
  },
  TOP: {
    name: 'Nadir',
    camEndPos: new Vector3(0, 85, 0),
    targetEndPos: new Vector3(0, -5, 0),
  },
};

export const CAMERAS_CONFIG = {
  perspectiveMinZ: 0.001, // determines how much camera can zoom to object/mesh. It's gonna ba 0.1 if lower than 0
  orthoGraphicMinZ: 20,
  perspectiveGizmoScaleRatio: 1,
  orthoGraphicGizmoScaleRatio: 0.3,
};

export const ORTHOPROJECTION_CONFIG = {
  scrollSpeed: 0.51, // determines how many units(meters) move per one scroll
  LODScale: {
    min: 1,
    max: 0.15,
  },
  gizmoScale: {
    min: 0.8,
    max: 0.005,
  },
  startingYPosition: 30,
  maxZoom: 20,
  //I was tweaking values till get proper result:
  // to zoom as close as possible to the plane, but not over zoom it
  camStartingPosition: 13,
};

export const ORTHOGRAPHIC_CAMERA_SPECS = {
  bottom: -12.5,
  left: -32,
  right: 32,
  top: 12.5,
};

export const SLIDER_OPTIONS = {
  MAX_VALUE: 100,
  MIN_VALUE: 1,
  DEFAULT_SPEED_LEVEL: 25,
  REDUCING_SPEED_LEVEL: 65,
};

export const VIEWFINDER_SLIDER_OPTIONS = {
  MIN_VALUE: 1,
  MAX_VALUE: 5,
};

export const CAMERA_DEFAULTS = {
  INITIAL_ALPHA: (3 * Math.PI) / 2,
  INITIAL_BETA: 1.2,
  INITIAL_RADIUS: 50,
  PANNING_SENSITIVITY_MULTIPLIER: 5000,
  ORTHO_MAX_PANNING_SENSIBILITY: 20000,
  ORTHO_HORIZONTAL_BOUND: 32,
  ZOOM_PANNING_SENSIBILITY_FACTOR: 6250,
  WHEEL_PRECISION_BASE: 101,
} as const;
